import { Box, IconButton, Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import moment from 'moment-timezone';
import React from 'react';
import { Link } from 'react-router-dom';
import { ILuckyDraw, LuckyDrawEventType } from '../../services/types';
import { RouteNames } from '../config';
import useStyles from './styles';

interface IProps {
  menuType: 'giftbox' | 'event';
  luckyDraws: ILuckyDraw[] | undefined;
  onClickRow: (luckyDraw: ILuckyDraw) => void;
  onChangeActivation: (luckyDraw: ILuckyDraw) => void;
  onClickDeleteButton: (luckyDraw: ILuckyDraw) => void;
}

const minutesToHour = (minutesNumber: number) => {
  const minutes = minutesNumber / 60;
  return `${minutes === 0 ? 12 : minutes} ${minutes < 12 ? 'AM' : 'PM'}`;
};

const LuckyDrawList = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { menuType, luckyDraws } = props;

  if (luckyDraws && luckyDraws.length === 0) {
    return (
      <Paper>
        <Box display="flex" justifyContent="center" alignItems="center" className={classes.noDataBox} flexDirection="column">
          <Typography>No data</Typography>
          <Typography variant="caption">{'Tap the "Create Lucky draw" at the top to create a first lucky draw.'}</Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center">Title</TableCell>
            {menuType !== 'giftbox' && (
              <React.Fragment>
                <TableCell align="center">Description</TableCell>
                <TableCell align="center">Event Type</TableCell>
                <TableCell align="center">SegmentId</TableCell>
                <TableCell align="center">Estimated # of participants</TableCell>
                <TableCell align="center">Countdown</TableCell>
                <TableCell align="center">Cooldown</TableCell>
                <TableCell align="center">Expired At</TableCell>
              </React.Fragment>
            )}
            {menuType === 'giftbox' && (
              <React.Fragment>
                <TableCell align="center">Estimated # of participants</TableCell>
                <TableCell align="center">Live Time</TableCell>
                <TableCell align="center">Schedule</TableCell>
              </React.Fragment>
            )}
            {menuType !== 'giftbox' && <TableCell align="center">Status</TableCell>}
            <TableCell align="center">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {luckyDraws &&
            luckyDraws.map((ld, idx) => (
              <TableRow
                component={Link}
                to={`${menuType === 'giftbox' ? RouteNames.GiftboxLuckyDraw : RouteNames.LuckyDraw}/v/${ld.id}`}
                key={ld.id}
                hover
                onClick={() => {
                  if (!ld.id) {
                    return;
                  }

                  props.onClickRow(ld);
                }}
              >
                <TableCell align="center">{ld.id}</TableCell>
                <TableCell align="center">{ld.title}</TableCell>
                {menuType !== 'giftbox' && (
                  <React.Fragment>
                    <TableCell align="center">{ld.description}</TableCell>
                    <TableCell align="center">
                      {ld.eventType} {ld.eventType === LuckyDrawEventType.Chatroom ? `(${ld.chatroomStoryId})` : ''}
                    </TableCell>
                    <TableCell align="center">{ld.segmentId}</TableCell>
                    <TableCell align="center">{ld.participantsNum}</TableCell>
                    <TableCell align="center">{ld.countdownMinutes}</TableCell>
                    <TableCell align="center">{ld.cooldownMinutes}</TableCell>
                    <TableCell align="center">{ld.expiredAt && moment(ld.expiredAt).format('llll')}</TableCell>
                  </React.Fragment>
                )}
                {menuType === 'giftbox' && (
                  <React.Fragment>
                    <TableCell align="center">{ld.participantsNum}</TableCell>
                    <TableCell align="center">
                      {minutesToHour(ld.cooldownMinutes)} - {minutesToHour(ld.countdownMinutes + ld.cooldownMinutes)}
                    </TableCell>
                    <TableCell align="center">
                      {moment(ld.startsAt).format('lll')} -{' '}
                      {ld.expiredAt ? moment(ld.expiredAt).format('lll') : <span style={{ display: 'inline-block', width: 135 }} />}
                    </TableCell>
                  </React.Fragment>
                )}
                {menuType !== 'giftbox' && (
                  <TableCell align="center">
                    <Tooltip title={moment(ld.expiredAt).isAfter(moment()) ? 'Activated' : 'Deactivated'} placement="bottom">
                      <Switch
                        disabled={!moment(ld.expiredAt).isAfter(moment())}
                        color="primary"
                        checked={moment(ld.expiredAt).isAfter(moment())}
                        onClick={e => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onChange={() => {
                          props.onChangeActivation(ld);
                        }}
                        value={idx}
                      />
                    </Tooltip>
                  </TableCell>
                )}
                <TableCell align="center">
                  <Tooltip title={moment(ld.expiredAt).isAfter(moment()) ? 'You cannot delete it in the active state.' : ''} placement="left-end">
                    <IconButton
                      style={{
                        opacity: moment(ld.expiredAt).isAfter(moment()) ? 0.25 : 1,
                      }}
                      color={moment(ld.expiredAt).isAfter(moment()) ? 'default' : 'primary'}
                      disableFocusRipple={moment(ld.expiredAt).isAfter(moment())}
                      disableTouchRipple={moment(ld.expiredAt).isAfter(moment())}
                      disableRipple={moment(ld.expiredAt).isAfter(moment())}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        props.onClickDeleteButton(ld);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default LuckyDrawList;
